<div class="list-group">
  <a
    *ngFor="let response of quickResponseList"
    class="list-group-item list-group-item-action"
    (click)="onResponseClick(response)"
    >{{ response }}</a
  >
</div>
